Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "OfferingTagLine2532211523",
  {"root":"OfferingTagLine2532211523--root"},
  "",
  2,
  "OfferingTagLine2532211523"
);

